import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_fixed_asset_register_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  category_guid: fromDatatype.GuidDataFieldInterface;
  pic_name: fromDatatype.VarcharDatatypeInterface;
  guid_company: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  purchase_date: fromDatatype.TimestampTzDatatypeInterface;
  purchase_price: fromDatatype.NumericDatatypeInterface;
  depr_method: fromDatatype.TextDatatypeInterface;
  fixed_asset_status: fromDatatype.VarcharDatatypeInterface;
  fixed_asset_type: fromDatatype.VarcharDatatypeInterface;
  guid_segment: fromDatatype.VarcharDatatypeInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  employee_guid: fromDatatype.GuidDataFieldInterface;
  serial_no: fromDatatype.VarcharDatatypeInterface;
  warranty_expiry: fromDatatype.TimestampTzDatatypeInterface;
  depr_start: fromDatatype.TimestampTzDatatypeInterface;
  residual_value: fromDatatype.NumericDatatypeInterface;
  depr_ave_method: fromDatatype.VarcharDatatypeInterface;
  depr_rate: fromDatatype.NumericDatatypeInterface;
  useful_life: fromDatatype.NumericDatatypeInterface;
  fi_acc_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
  fi_acc_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
  fi_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
  fi_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  sub_ledger_guid: fromDatatype.GuidDataFieldInterface;
  qty: fromDatatype.NumericDatatypeInterface;
}

export class bl_fi_fixed_asset_register_hdr_RowClass implements bl_fi_fixed_asset_register_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  category_guid: fromDatatype.GuidDataFieldInterface;
  pic_name: fromDatatype.VarcharDatatypeInterface;
  guid_company: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  purchase_date: fromDatatype.TimestampTzDatatypeInterface;
  purchase_price: fromDatatype.NumericDatatypeInterface;
  depr_method: fromDatatype.TextDatatypeInterface;
  fixed_asset_status: fromDatatype.VarcharDatatypeInterface;
  fixed_asset_type: fromDatatype.VarcharDatatypeInterface;
  guid_segment: fromDatatype.VarcharDatatypeInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  employee_guid: fromDatatype.GuidDataFieldInterface;
  serial_no: fromDatatype.VarcharDatatypeInterface;
  warranty_expiry: fromDatatype.TimestampTzDatatypeInterface;
  depr_start: fromDatatype.TimestampTzDatatypeInterface;
  residual_value: fromDatatype.NumericDatatypeInterface;
  depr_ave_method: fromDatatype.VarcharDatatypeInterface;
  depr_rate: fromDatatype.NumericDatatypeInterface;
  useful_life: fromDatatype.NumericDatatypeInterface;
  fi_acc_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
  fi_acc_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
  fi_depr_glcode_guid: fromDatatype.GuidDataFieldInterface;
  fi_depr_subledger_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  sub_ledger_guid: fromDatatype.GuidDataFieldInterface;
  qty: fromDatatype.NumericDatatypeInterface;
}
